<template>
  <div id="app">
    <admin v-if="$route.name == 'Login'">
      <router-view />
    </admin>
    <layout v-else>
      <router-view />
    </layout>
  </div>
</template>

<script>
import layout from './layout/default.vue';
import admin from './layout/admin.vue';
export default {
  components: {
    layout,
    admin,
  },
  data() {
    return {
      showModalSessionExpiry: false,
    };
  },
};
</script>
